import { isArray, isBoolean, isNil, isNumber, isObject, isString, } from "lodash";
export const isPrimitive = (value) => isString(value) || isBoolean(value) || isNumber(value) || isNil(value);
// This differs from isEmpty from lodash around handling of primitives
export const isEmpty = (val) => {
    if (isNil(val))
        return true;
    if (isString(val))
        return val.trim() === "";
    if (isArray(val))
        return val.length === 0;
    if (isObject(val))
        return Object.keys(val).length === 0;
    return false;
};
export const isNilOrZero = (val) => val === 0 || val === "0" || val == null;
//# sourceMappingURL=validations.js.map